import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/point-of-concurrency',
  component: () => import('../../routes/PointOfConcurrencyCalculator.svelte'),
  card: {
    id: 'point-of-concurrency',
    title: 'Point of Concurrency',
    description: 'Find the centroid, circumcenter, incenter, and orthocenter of a triangle with interactive vertex inputs.',
    icon: 'hub',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/point-of-concurrency',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Point of Concurrency Calculator – Triangle Centroid, Circumcenter & More',
    description:
      'Free point of concurrency calculator finds the centroid, circumcenter, incenter, and orthocenter of any triangle. Enter three vertex coordinates to calculate all concurrency points instantly.',
  },
};

export default meta;